import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import { MenuSearchInput } from '../filters/MenuSearchInput.js';
import { FILTER_BAR_ROW_SX } from '../filters/menuStyles.js';
import { SingleSelectControl } from '../filters/SingleSelectControl.js';
import type { CatalogFilterOptions, CatalogFilterState } from './catalogFilters.js';

interface CatalogFilterBarProps {
  options: CatalogFilterOptions;
  filters: CatalogFilterState;
  onChange: (filters: CatalogFilterState) => void;
}

export function CatalogFilterBar({ options, filters, onChange }: CatalogFilterBarProps): ReactNode {
  return (
    <Box sx={{ ...FILTER_BAR_ROW_SX, alignItems: 'normal' }}>
      <Box sx={{ display: 'flex', width: 210 }}>
        <MenuSearchInput
          placeholder="Search"
          value={filters.search}
          onChange={(search) => onChange({ ...filters, search })}
        />
      </Box>
      <SingleSelectControl
        label="ROLE"
        options={options.roles}
        value={filters.role}
        onChange={(role) => onChange({ ...filters, role })}
      />
      <SingleSelectControl
        label="STAGE"
        options={options.stages}
        value={filters.stage}
        onChange={(stage) => onChange({ ...filters, stage })}
      />
      <SingleSelectControl
        label="CATEGORY"
        options={options.categories}
        value={filters.category}
        onChange={(category) => onChange({ ...filters, category })}
      />
      <SingleSelectControl
        label="OUTCOME"
        options={options.outcomes}
        value={filters.outcome}
        onChange={(outcome) => onChange({ ...filters, outcome })}
      />
    </Box>
  );
}
